import i18n from './index.js'
export default {//法语
  translateText: {
    shoppingcart: "panier",
    loginorrefisterText: "connexion/inscription",
    logoutText: "se déconnecter",
    personcenterText: "centre personnel",
    placeholderText: "veuillez sélectionner",
    loginText: "se connecter",
    registerText: "enregistrement",
    emailText: "boîte aux lettres",
    pwdText: "mot de passe",
    forgetpwdText: "mot de passe oublié?",
    nameText: "nom",
    surnameText: "nom de famille",
    mobileText: "téléphone",
    setPwdText: "définir un mot de passe",
    countryText: "pays",
    company: "La société",
    birthday: "anniversaire",
    yearText: "année",
    mouthText: "mois",
    dayText: "jour",
    confirmpwdText: "confirmer le mot de passe",
    agreeText1: "j’ai lu et j’accepte",
    agreeText2: "conditions d’utilisation",
    agreeText3: "et",
    agreeText4: "déclaration de confidentialité",
    agreeText5: "et j’accepte que certaines de Mes Informations personnelles soient traitées à l’étranger conformément à la déclaration de confidentialité",
    emailplaceholder: 'veuillez entrer un email',
    subscribetitleText: '’abonnez-vous à notre newsletter',
    subscribeText: 'abonnement',
    shareToText: 'partager jusqu’à',
    searchText: 'recherche',
    subtractmoneyText: "jusqu’à 600 moins",
    magnanimitycouponText: "un grand nombre de coupons à retirer",
    drawText: "obtenir maintenant",
    discountText: "super beaucoup de rabais",
    purchaseText: "acheter maintenant ",
    composecouponText: "achat combiné",
    manyDiscountsText: "beaucoup d’offres",
    recommendtitleText: "recommandé pour vous",
    hotsaleproductyitleText: "produits de vente chauds",
    guessLiketitleText: "devinez que vous aimez ",
    NoDataText: "pas encore de données",
    appraiseText: "évaluation",
    certificate: "coupon",
    collectText: "la collection",
    addCartText: "ajouter au panier",
    enterkeywordsText: "entrez les mots-clés",
    useNowText: "utiliser immédiatement",
    vouchernoText: "numéro de coupon",
    placeholderyearText: "sélectionner l’année",
    placeholdermouthText: "choisir un mois ",
    placeholderdayText: "choisir un jour ",
    // 优惠券页面
    breadcrumbItemText1: 'super',
    breadcrumbItemText2: 'niveau',
    breadcrumbItemText3: 'grand',
    breadcrumbItemText4: 'bénéfice',
    breadcrumbItemText5: 'le',
    magnanimitydrawText: 'des coupons massifs que vous pouvez récupérer',
    availablecouponstitleText: 'Produits de bons disponibles',
    drawbtnText: 'récupéré',
    universalText: 'universel sur tout le terrain',
    useText: 'utilisation',
    limitText: 'limited',
    fullText: 'plein',
    subtractText: 'soustraire',
    // 折扣
    discountitemText1: 'Remises en continu ,',
    discountitemText2: 'Joyhui lianlian',
    // 组合
    commoditydiscountitemText1: 'Acheter en combinaison ,',
    commoditydiscountitemText2: 'Offres nombreuses et nombreuses',
    combinedpriceText: 'Prix de combinaison',
    economizeText: 'Des économies',
    buynowText: "Acheter maintenant acheter",
    // 产品
    ourproductsText: 'nos produits',
    productcategoryText: '’catégories de produits',
    recommendtarText: 'recommandation',
    newText: '’nouvel arrivage',
    salesvolumetarText: 'volume des ventes',
    pricetarText: 'prix',
    // 博客
    blogmanagementText: "blogs populaires",
    latestblogsText: "derniers blogs",
    relatedrlogsText: "blogs connexes",
    priceIncreasecommentText: "observations",
    commentsectionTtxt: "zone de commentaires",
    participatingcommentsText: "participation",
    // 论坛
    postingText: "publier un message",
    topicsText: "sujet",
    replyText: "répondre",
    viewText: "afficher",
    lastreplyText: "dernière réponse",
    publishText: "publier",
    placeholdertypeText: "s’il vous plaît sélectionner une catégorie de sujet",
    placeholdertitleText: "veuillez entrer un titre",
    placeholdercontentsText: "veuillez entrer le contenu ",
    fromtopicText: "depuis le sujet: ",
    firstfloor: "1er étage",
    floorText: "le bâtiment",
    fromText: "de:",
    postreplyText: "publier une réponse",
    // 个人中心 - 我的订单
    myorderText: "Mes Commandes",
    mycommentsText: "Mes Commentaires",
    mycollectionText: "ma collection",
    couponText: "coupon",
    shippingaddressText: "adresse de livraison ",
    myPostText: "Mes Messages",
    personalinformationText: "informations personnelles",
    editText: "éditer",
    allordersText: "toutes les commandes",
    unpaidText: "à payer",
    shippedText: "à expédier",
    receivedText: "à recevoir",
    evaluatedText: "à évaluer",
    baidText: "paiement en remplacement",
    completedText: "terminé",
    productinfText: "informations sur le produit",
    unitpricethText: "prix unitaire",
    quantitythText: "quantité",
    actualpaymentthText: "paiement réel",
    transactionstatusthText: "statut de la transaction",
    operationthText: "opération",
    ordernumberText: "numéro de commande",
    orderdetailsText: "détails de la commande",
    cancelorderText: "annuler la commande ",
    confirmText: "ok",
    cancelText: "annuler",
    deleteordertitle: "supprimer définitivement la commande en cours?",
    successfultradeText: "transaction réussie",
    paymentText: "effectuer un paiement",
    confirmreceiptText: "confirmation de réception",
    nncommentText: 'pas encore de commentaires',
    // 个人中心 - 我的评论
    productText: "produit",
    productdetailText: "détails d’évaluation",
    replyblogText: "répondre au blog:",
    //个人中心 - 收货地址
    addseliveryaddressText: "nouvelle adresse de livraison",
    addaddresstitleText1: "enregistré",
    addaddresstitleText2: "l’adresse de la barre, peut également sauver",
    addaddresstitleText3: "adresse de la barre",
    defaultText: "par défaut",
    consigneeText: "destinataire:",
    addressText: "adresse où se trouve: ",
    fulladdressText: "adresse complète:",
    setdefaultText: "set to default",
    mobilephoneText: "téléphone portable:",
    viewmoreText: "voir plus",
    replypostText: "répondre à un message: ",
    // 个人中心 - 个人信息
    nameLabel: "nom",
    sexlabel: "genre",
    modifyavatarText: "modifier la photo de profil",
    sexmanText: "mâle",
    sexwomanText: "femme",
    secrecyText: "confidentialité",
    replaceText: "remplacer",
    saveText: "sauvegarder",
    oldpasswordText: "mot de passe original",
    newpasswordText: "nouveau mot de passe",
    confirmpasswordText: "confirmer le mot de passe",
    opdpleasolderText: "veuillez entrer le mot de passe original",
    newpleasolderText: "veuillez entrer un nouveau mot de passe",
    unboundText: "non lié",
    bindingText: "lier",
    unbindingText: "délier",
    // 个人中心-个人信息
    regionText: "la région ",
    addconsigneleasolderText: "veuillez remplir le destinataire nom",
    countrypleasolderText: "veuillez sélectionner un pays",
    provinceleasolderText: "veuillez sélectionner la province",
    citypleasolderText: "veuillez sélectionner une ville",
    areapleasolderText: "veuillez sélectionner une région",
    fulladdressTextpleasolderText: " indiquer l’adresse complète",
    addconsignephoneleasolderText: "veuillez remplir le destinataire numéro de téléphone mobile",
    emailpleasolderText: "s’il vous plaît entrer une adresse e-mail ",
    phoneText: '’numéro de mobile',
    uploadimgText: "télécharger une image",
    updateuserface: "modifier avatar",
    uploadimgtitle1: "Prise en charge des images au format JPG, jpeg, PNG",
    uploadimgtitle2: "Taille recommandée: 200*200 ou image à échelle égale",
    updateemailText: "modifier l’email ",
    updatemobileText: "modifier le numéro de téléphone",
    dialogemailtitle: "adresse e-mail",
    dialogmobiletitle: "numéro de téléphone portable",
    dialogheadertitle: "Entrée associée à votre compte jinger",
    continueText: "continue",
    verificationinformation: "Vérifier les informations",
    verificationinformationTitle1: "Pour continuer, veuillez compléter cette étape de vérification. Nous avons offert",
    verificationinformationTitle2: "un captcha a été envoyé. S’il vous plaît entrer ci-dessous.",
    verificationcode: "Code de vérification",
    newtitle: "La nouvelle",
    dialognewmobiletitle: "Entrez le nouveau numéro de téléphone que vous souhaitez associer. Et cliquez pour confirmer le remplacement",
    confirmpbtnText: "confirmation",
    titlecpuntryselect: "sélectionner le pays",
    hotcountrytitle: "pays chauds",
    aboutusText: "a propos de nous",
    // 订单详情
    havequestionsText: "j’ai des questions",
    preferentialText: "offres",
    enquiryText: "enquête",
    combinationdiscountText: "offre combinée ",
    introduceText: "introduction",
    buyermycommentsText: "avis de l’acheteur",
    starText: "étoile",
    yourmailboxText: "votre boîte aux lettres",
    placeholderquestionText: "s’il vous plaît écrivez votre question",
    uploadimglimtText: "veuillez télécharger un fichier JPG/GIF/PNG. La taille de l’image ne doit pas dépasser 2 mo",
    submitbtnText: "soumettre",
    // 购物车
    selectText: "sélection",
    tipscartsText: "produits sélectionnés (frais de port non inclus)",
    settlementText: "règlement",
    selectallText: " tout sélectionner",
    amountText: "montant",
    addtofavoritesText: "ajouter aux favoris",
    havecollectedText: "collected",
    tipdelecteproduct: "supprimer définitivement le produit actuel?",
    deleteText: "supprimer",
    tipclearcart: "sûr de vider votre panier?",
    clearcartText: "vider le panier",
    totalText: "total",
    totaltipText: "article (hors frais de port):",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_fr.js